import {Pipe, PipeTransform} from '@angular/core';
import {UtilitiesService} from "../../core/_services/utilities.service";

@Pipe({
    name: 'truncateText'
})
export class TruncateTextPipe implements PipeTransform {

    transform(value: string, limit = 20, trail = '...'): string {
        if (UtilitiesService.isNotEmpty(value) && value.length > limit) {
            return value.substring(0, limit) + trail;
        }
        return value || '';
    } // transform()

} // TruncateTextPipe
